import React from "react"
import i18next from '../i18n/config';
import { Link, Trans, useTranslation, useI18next }
from 'gatsby-plugin-react-i18next';
import { Helmet }
from "react-helmet";
//const $ = require("jquery");
import Suwak from "../layouts/Suwak"


//import iko_poprzedni from "../img/sloiki/iko_poprzedni.png";
//import iko_nastepny  from "../img/sloiki/iko_nastepny.png";

import iko_jars from "../img/G_opakowania_kawy_rozpuszczalnej_9/iko_sloiki.png"
import iko_sticks from "../img/G_opakowania_kawy_rozpuszczalnej_9/iko_stick.png"
import iko_cans from "../img/G_opakowania_kawy_rozpuszczalnej_9/iko_puszki.png"
import iko_doypacks from "../img/G_opakowania_kawy_rozpuszczalnej_9/iko_doypack.png"
import ImgOurCoffeeBack from "../img/D_kawa_ziarnista_18/iko_powrot_nasze_kawy.png";
// import ImgStickMain from "../img/G_opakowania_kawy_rozpuszczalnej_9/2_stick/rozpuszczalne_stick.png"
import ImgStickMain from "../img/G_opakowania_kawy_rozpuszczalnej_9/2_stick/rozpuszczalne_stick_karton.png"
import ImgCansMain from "../img/G_opakowania_kawy_rozpuszczalnej_9/3_puszki/rozpuszczalne_puszka.png"
import ImgDoypackMain from "../img/G_opakowania_kawy_rozpuszczalnej_9/4_doypack/rozpuszczalne_doypack.png"



export default function JarsGalleryBig(props) {





    if (typeof window !== `undefined`) {
//        const script2 = document.createElement("script");
//        script2.src = '/js/jQuery.js';
////        script2.async = true;
//        document.head.appendChild(script2);

//        const script3 = document.createElement("script");
//        script3.src = 'https://unpkg.com/spritespin@x.x.x/release/spritespin.js';
//        script3.defer = true;
//
//        document.head.appendChild(script3);
//




//        var script4 = document.createElement('script');
//        script4.src = '/js/JarsGallery.js';
//        script4.defer = true;
//        document.head.appendChild(script4);

//
//        const script2 = document.createElement("script");
//        script2.src = '/js/jQuery.js';
////        script2.async = true;
//        document.head.appendChild(script2);
//
//        const script2 = document.createElement("script");
//        script2.src = '/js/jQuery.js';
////        script2.async = true;
//        document.head.appendChild(script2);
//
//        const script2 = document.createElement("script");
//        script2.src = '/js/jQuery.js';
////        script2.async = true;
//        document.head.appendChild(script2);

        document.jarFromUrl = document.location.hash;
//        document.jarFromUrl2 = document.location.hash.substring(1);
//        console.log("initjar select:", document.jarFromUrl2);
//
//        if (document.jarFromUrl2 == "") {
//            console.log(document);
//
//            return;
//        }




        const script2 = document.createElement("script");
        script2.src = '/js/jQuery.js';
        script2.onload = function () {
            const script3 = document.createElement("script");
            script3.src = '/js/spritespin.js';
//          script3.defer = true;
            script3.onload = function () {
                const script4 = document.createElement("script");
                script4.src = '/js/JarsGallery.js';
                //            script3.defer = true;
                script4.onload = function () {
                    setTimeout(function () {
                        try {
                            document.JarsGalleryBigApi.init();
                        } catch (error) {
                        }
                    }, 11);
                };
                document.head.appendChild(script4);
            };
            document.head.appendChild(script3);
        };
//        script2.defer = true;
        document.head.appendChild(script2);

//            script4.defer = true;

















    }





    return (
            <React.Fragment>

                <section id="instantpack" class="finished firstSection">
                    <h1>{i18next.t('InstantPackagingH1')}</h1>
                    <p>{i18next.t('InstantPackagingP')}</p>
                    <div class="features">
                        <div class="feature" onClick={() => document.scrolltosection("JarsGalleryBigSection")} >
                            <a>
                                <div><img loading="lazy" src={iko_jars} alt="Instanta Jars Packaging Icon" /></div>
                                <p>{i18next.t('InstantPackagingJars')}</p>
                            </a>
                        </div>
                        <div class="feature" onClick={() => document.scrolltosection("sticks")} >
                            <a>
                                <div><img loading="lazy" src={iko_sticks} alt="Instanta Sticks Packaging Icon" /></div>
                                <p>{i18next.t('InstantPackagingSticks')}</p>
                            </a>
                        </div>
                        <div class="feature" onClick={() => document.scrolltosection("cans")} >
                            <a>
                                <div><img loading="lazy" src={iko_cans} alt="Instanta Cans Packaging Icon" /></div>
                                <p>{i18next.t('InstantPackagingCans')}</p>
                            </a>
                        </div>
                        <div class="feature" onClick={() => document.scrolltosection("doypacks")} >
                            <a>
                                <div><img loading="lazy" src={iko_doypacks} alt="Instanta Doypacks Packaging Icon" /></div>
                                <p>{i18next.t('InstantPackagingDoypacks')}</p>
                            </a>
                        </div>
                    </div>

                    <aside class="mininavi">
                        <div>
                            <Link to={'/OurPackaging/Packaging/'}> <img loading="lazy" src={ImgOurCoffeeBack} alt="Instanta Coffee Back Icon" />
                            <p>{i18next.t('CapsulesMiniNaviBack')}</p>
                            </Link>
                        </div>
                    </aside>
                </section>


























                <section id="JarsGalleryBigSection">



                    <div class="JarsGalleryBig">


                        <h2>{i18next.t('InstantPackagingJarsH2')}</h2>
                        <p>{i18next.t('InstantPackagingJarsP')}</p>

                        <a class="noselect" id="iko_poprzedni" onClick={() => document.JarsGalleryBigApi.backClick()}></a>
                        <a class="noselect" id="iko_nastepny" onClick={() => document.JarsGalleryBigApi.nextClick()}></a>






                        <div id="Galleryisloading">
                            <br /><br /><br /> <br /><br /><br /><br /><br /> <br /><br />
                            <br /><br /><br /> <br /><br /><br /><br /><br /> <br /><br />
                            <div class="loadingZiarenko rotate"></div>
                            <br /><br /><br />
                            <p>{i18next.t('GalleryLoading')}</p>

                        </div>
                        <div id="JarsGalleryBigClassAll" class="is-visible" >

                        </div>


                    </div>



                </section>
                <section id="JarsGalleryMiniSection">
                    <div id="JarsGalleryMiniClassAll" >

                    </div>

                    <div class="links">
                        <div class="link">
                            <Link to={'/OurCoffees/InstantCoffee'}>
                            <p>{i18next.t('InstantPackagingLink')}</p>
                            </Link>
                        </div>
                        <div class="link">
                            <Link to={'/Collaboration/'}>
                            <p>{i18next.t('CapsulesLinkCollaboration')}</p>
                            </Link>
                        </div>
                        <div class="link">
                            <Link to={'/OurPackaging/Design/'}>
                            <p>{i18next.t('CustomProductLink3')}</p>
                            </Link>
                        </div>
                    </div>
                </section>


































                <section id="sticks" class="freeze-dried main">
                    <div class="image"><img loading="lazy" src={ImgStickMain} loading="lazy" alt="Instanta Coffee Ground Bag" />
                    </div>
                    <div class="text">
                        <h2>{i18next.t('InstantPackagingSticksH2')}</h2>
                        <p>{i18next.t('InstantPackagingSticksP')}</p>


                        <div class="links">
                            <div class="link">
                                <Link to={'/OurCoffees/InstantCoffee'}>
                                <p>{i18next.t('InstantPackagingLink')}</p>
                                </Link>
                            </div>
                            <div class="link">
                                <Link to={'/Collaboration/'}>
                                <p>{i18next.t('CapsulesLinkCollaboration')}</p>
                                </Link>
                            </div>
                            <div class="link">
                                <Link to={'/OurPackaging/Design/'}>
                                <p>{i18next.t('CustomProductLink3')}</p>
                                </Link>
                            </div>
                        </div>

                    </div>
                </section>

                <section id="cans" class="powdered main">
                    <div class="image"><img loading="lazy" src={ImgCansMain} alt="Instanta Coffee Ground Vacuum Pack" />
                    </div>
                    <div class="text">
                        <h2>{i18next.t('InstantPackagingCansH2')}</h2>
                        <p>{i18next.t('InstantPackagingCansP')}</p>


                        <div class="links">
                            <div class="link">
                                <Link to={'/OurCoffees/InstantCoffee'}>
                                <p>{i18next.t('InstantPackagingLink')}</p>
                                </Link>
                            </div>
                            <div class="link">
                                <Link to={'/Collaboration/'}>
                                <p>{i18next.t('CapsulesLinkCollaboration')}</p>
                                </Link>
                            </div>
                            <div class="link">
                                <Link to={'/OurPackaging/Design/'}>
                                <p>{i18next.t('CustomProductLink3')}</p>
                                </Link>
                            </div>
                        </div>

                    </div>
                </section>
                <section id="doypacks" class="granulated main">
                    <div class="image"><img loading="lazy" src={ImgDoypackMain} alt="Instanta Coffee Stand-Up Pack" /></div>

                    <div class="text">
                        <h2>{i18next.t('InstantPackagingDoypackH2')}</h2>
                        <p>{i18next.t('InstantPackagingDoypackP')}</p>

                        <div class="links">
                            <div class="link">
                                <Link to={'/OurCoffees/InstantCoffee'}>
                                <p>{i18next.t('InstantPackagingLink')}</p>
                                </Link>
                            </div>
                            <div class="link">
                                <Link to={'/Collaboration/'}>
                                <p>{i18next.t('CapsulesLinkCollaboration')}</p>
                                </Link>
                            </div>
                            <div class="link">
                                <Link to={'/OurPackaging/Design/'}>
                                <p>{i18next.t('CustomProductLink3')}</p>
                                </Link>
                            </div>
                        </div>

                    </div>
                </section>


            </React.Fragment>

            )


}